module.exports = __webpack_public_path__ + "static/media/home.8ee7a8e6.gif";